import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import * as maptilersdk from '@maptiler/sdk'
import { markerCreateRequest, markerUpdateRequest } from '../../../../action/marker-actions'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { MakeTextInput, GetHeader } from '../add-marker/addHandlers';
import DragAndDropImage from '../../../main-ui/left-toolbar/common/photo-details/dragAndDropImage';
import { ColorCodes } from '../../../main-ui/left-toolbar/common/marker-details/dummy';
import { photoCreateRequest, photoUpdateRequest } from '../../../../action/photo-actions';
import { buildPhotoMarkerElement } from '../../render-3d-photos';
import ImageViewModel from '../../../main-ui/left-toolbar/common/photo-details/imageView';
import Lock from '@mui/icons-material/Lock'
import LockOpen from '@mui/icons-material/LockOpen'

const ThreeDPhotoMarkerDetails = (props) => {
  const [state, setState] = useState({ latitude: '', longitude: '', name: props.leftToolbarState?.editable?.name ? props.leftToolbarState.editable.name : `Photo - ${props.photos.length}`, notes: '' })
  const [colorMarker, setColorMarker] = useState("9ECC3B");
  const [loadSpinner, setLoadSpinner] = useState(false);
  const [isImageUploaded, setIsImageUploaded] = useState(true);
  const [imageUrl, setImageUrl] = useState();
  const [imageViewModel, setImageViewModel] = useState(false)
  const [imageFile, setImageFile] = useState()
  let { editable } = props.leftToolbarState
  const isEditing = !!editable
  const [locationSet, setLocationSet] = useState(isEditing)
  const locationSetRef = useRef(isEditing)
  let { userPreferences } = props

  let jsonObjectFunction = (editable) => {
    if (editable) {
      if (typeof (editable.weatherObservation) == 'object') {
        let temp = editable.weatherObservation.weatherObservation.tempF
        let iconUrl = editable.weatherObservation.weatherObservation.baseIconUrl + editable.weatherObservation.weatherObservation.weatherIcon
        let weatherPrimary = editable.weatherObservation.weatherObservation.weatherPrimary
        return { temparature: temp, iconUrl: iconUrl, weatherPrimary: weatherPrimary }
      } else if (typeof (editable.weatherObservation) == 'string') {
        let jasonData = JSON.parse(editable.weatherObservation);
        let temp = jasonData.WeatherObservation.TempF
        let iconUrl = jasonData.WeatherObservation.BaseIconUrl + jasonData.WeatherObservation.WeatherIcon
        let weatherPrimary = jasonData.WeatherObservation.WeatherPrimary
        return { temparature: temp, iconUrl: iconUrl, weatherPrimary: weatherPrimary }
      }
    } else {
      return null
    }
  }
  let jsonObject = editable && jsonObjectFunction(editable)

  let markerRef = useRef(null);
  const mouseMoveHandlerRef = useRef(null)
  const clickHandlerRef = useRef(null)

  const round6 = v => Math.round(v * 1e6) / 1e6

  function mapFunction(color, lat, lng, imgUrl) {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return

    if (markerRef.current) { markerRef.current.remove(); markerRef.current = null }

    const center = map.getCenter()
    const markerLat = lat || center.lat
    const markerLng = lng || center.lng

    const el = buildPhotoMarkerElement(color, imgUrl)
    el.style.cursor = 'default'

    const marker = new maptilersdk.Marker({ element: el, draggable: false, anchor: 'bottom', pitchAlignment: 'viewport', rotationAlignment: 'viewport' })
      .setLngLat([markerLng, markerLat])
      .addTo(map)

    markerRef.current = marker
    setState(prev => ({ ...prev, latitude: String(round6(markerLat)), longitude: String(round6(markerLng)) }))
  }

  const startMoveMode = () => {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return
    setLocationSet(false)
    locationSetRef.current = false
    map.getCanvas().style.cursor = 'crosshair'

    if (mouseMoveHandlerRef.current) map.off('mousemove', mouseMoveHandlerRef.current)
    if (clickHandlerRef.current) map.off('click', clickHandlerRef.current)

    const onMove = (e) => {
      if (!e.lngLat) return
      const { lat, lng } = e.lngLat
      if (markerRef.current) markerRef.current.setLngLat([lng, lat])
      setState(prev => ({ ...prev, latitude: String(round6(lat)), longitude: String(round6(lng)) }))
    }
    const onClick = (e) => {
      const { lat, lng } = e.lngLat
      if (markerRef.current) markerRef.current.setLngLat([lng, lat])
      setState(prev => ({ ...prev, latitude: String(round6(lat)), longitude: String(round6(lng)) }))
      stopMoveMode()
    }
    map.on('mousemove', onMove)
    map.once('click', onClick)
    mouseMoveHandlerRef.current = onMove
    clickHandlerRef.current = onClick
  }

  const stopMoveMode = () => {
    const map = props.mapReferenceThreed
    setLocationSet(true)
    locationSetRef.current = true
    if (!map || typeof map.getCenter !== 'function') return
    map.getCanvas().style.cursor = ''
    if (mouseMoveHandlerRef.current) { map.off('mousemove', mouseMoveHandlerRef.current); mouseMoveHandlerRef.current = null }
    if (clickHandlerRef.current)    { map.off('click',     clickHandlerRef.current);    clickHandlerRef.current = null }
  }

  useEffect(() => {
    const map = props.mapReferenceThreed
    if (!map || typeof map.getCenter !== 'function') return

    if (props.leftToolbarState.editable) {
      setState({ latitude: String(editable.latitude ?? ''), longitude: String(editable.longitude ?? ''), name: editable.name, notes: editable.notes })
      setIsImageUploaded(false)
      let colorValue = editable?.color || ''
      if (colorValue.startsWith('#')) colorValue = colorValue.substring(1)
      setColorMarker(colorValue)
      setImageUrl(editable.imageUrl)
      mapFunction(editable.color, editable.latitude, editable.longitude, editable.imageUrl)
      // Edit mode: start locked
    }
    // New photo: move mode starts after image is uploaded (handled in handleSetPhoto)

    return () => {
      if (mouseMoveHandlerRef.current) { map.off('mousemove', mouseMoveHandlerRef.current); mouseMoveHandlerRef.current = null }
      if (clickHandlerRef.current)    { map.off('click',     clickHandlerRef.current);    clickHandlerRef.current = null }
      map.getCanvas().style.cursor = ''
      if (markerRef.current) { markerRef.current.remove(); markerRef.current = null }
    }
  }, [props.mapReferenceThreed])

  let rebuild = (color) => {
    mapFunction(color, state.latitude, state.longitude, imageUrl)
  }

  const handleInputChange = (field, value) => {
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const savePhoto = () => {
    const { photoCreateRequest, photoUpdateRequest, leftToolbarState, collapseLeftToolbar, user } = props

    let photoInfo = {
      color: colorMarker,
      name: state.name,
      typeId: 1,
      notes: state.notes,
      latitude: state.latitude,
      longitude: state.longitude,
      altitude: 0
    },
      data = new FormData(),
      infoString = JSON.stringify(photoInfo)
    data.append('photo', imageFile)
    data.append('photoInfo', infoString)
    setLoadSpinner(true)
    if (leftToolbarState.editable) {
      //update
      photoInfo['thumbnailUrl'] = imageFile
      photoInfo['imageUrl'] = imageFile
      photoInfo['userId'] = user.id
      photoInfo['id'] = leftToolbarState.editable.id

      const handlePhotoUpdateRequest = async () => {
        try {
          const res = await photoUpdateRequest(photoInfo)
          if (res) {
            markerRef.current.remove();
            markerRef.current = null;
            setLoadSpinner(false)
          }
          collapseLeftToolbar()
        } catch (error) {
          console.log('Photo Update Failed', error)
        }
      }
      handlePhotoUpdateRequest()
    } else {
      //create
      const handlePhotoCreateRequest = async () => {
        try {
          const res = await photoCreateRequest(data)
          collapseLeftToolbar()
          if (res) {
            setLoadSpinner(false)
          }
        } catch (error) {
          console.error('Photo Creation Failed', error)
        }
      }
      handlePhotoCreateRequest()
    }
  }

  const handleSetPhoto = (file) => {
    setIsImageUploaded(false)
    if (file) {
      const url = URL.createObjectURL(file)
      mapFunction(colorMarker, null, null, url)
      setImageUrl(url)
      setImageFile(file)
      // After placing the marker, enter move mode so user can position it
      startMoveMode()
    }
  }

  function photoMarkerIcon(color, isEditable) {
    const { editable, mapObj } = props.leftToolbarState
    let bgColor
    if (color && color.length > 1) {
      if (color.length <= 6 || color.length <= 7) {
        bgColor = color[0] == '#' ? color : '#' + color
      }
      else {
        bgColor = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
      }
    } else {
      bgColor = '9ECC3B'
    }
    const selectColor = (value) => {
      setColorMarker(value)
      rebuild(value)
    }

    return (
      <div className='image-color-change '>
        <label
          className='label-style'
          style={{
            fontSize: '14px',
            textTransform: 'capitalize'
          }}>Style:</label>
        <div style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {/* {!props.leftToolbarState.editable && <div style={{ width: '100%', textAlign: 'right' }}>
            <p
              style={{ textDecoration: 'underline', cursor: 'pointer', userSelect: 'none' }}
              onClick={() => this.inputEle.current.click()}
            >
              Change Image
            </p>
            <input
              type='file'
              accept='image/*,.png'
              ref={this.inputEle}
              style={{ display: 'none' }}
              onChange={onEditImage}
            ></input>
          </div>} */}
          <div
            className='file-drop-target-image'
            style={{ border: `5px solid ${bgColor[0] == '#' ? bgColor : '#' + bgColor}`, }}>
            <a>
              <img className='upload-image-icon-style'
                onClick={() => { handleImageViewModel() }}
                src={isEditable ? imageUrl : imageFile && URL.createObjectURL(imageFile)}
              >
              </img>
            </a>
          </div>
          <div className='select-color-container' style={{ display: 'flex', flexWrap: 'wrap', height: '90px', width: '96%', marginLeft: '6px', marginRight: '6px' }}>
            {ColorCodes.map((item, index) => {
              return (
                <div key={index} style={{ width: 'calc(14.28% - 10px)', height: '40px', margin: '5px' }}>
                  <a onClick={() => selectColor(item)}>
                    <div style={{ width: '30px', height: '20px', borderRadius: '5px', backgroundColor: '#' + item }}></div>
                  </a>
                  <div className={item === colorMarker ? 'bottom-box' : ''} ></div>
                </div>
              );
            })}
          </div>
        </div>
      </div >
    )
  }

  let handleImageViewModel = () => {
    setImageViewModel(true)
  }

  return (
    <>
      {loadSpinner &&
        <div className='markers-load-spinner'>
          <div className="loader-spinner"></div>
        </div>
      }

      <div style={{ position: 'relative' }}>
        <GetHeader
          title={props.leftToolbarState.editable ? "Edit" : "Add"}
          titleName="Photo"
          marginTop={5}
          absolute={true}
          collapseLeftToolbar={() => props.collapseLeftToolbar()}
        ></GetHeader>
        {(isEditing || imageUrl) && (
          locationSet
            ? <Lock onClick={startMoveMode}
                style={{ position: 'absolute', right: 8, top: 74, fontSize: 22, color: '#aaa', cursor: 'pointer' }} />
            : <LockOpen onClick={stopMoveMode}
                style={{ position: 'absolute', right: 8, top: 74, fontSize: 22, color: '#589500', cursor: 'pointer' }} />
        )}
      </div>

      <div style={{ width: '100%' }}>
        {imageUrl ?
          (
            <></>
          ) :
          (
            !props.leftToolbarState.editable && isImageUploaded &&
            <>
              <DragAndDropImage setPhoto={handleSetPhoto}></DragAndDropImage>
            </>
          )
        }
      </div >

      {!isImageUploaded &&
        <div className="tools-content">

          <div className="container-box">
            <div className="container-box-two" style={{ overflowY: "scroll", height: "calc(100vh - 145px)" }}>
              <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='name' width='92%' containerWidth='100%' access='false' displayVal={state.name}    ></MakeTextInput  >

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '10px',
              }}>
                <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='latitude' width='85%' access='false' displayVal={state.latitude} latVal={state.latitude} lngVal={state.longitude}  ></MakeTextInput  >
                <MakeTextInput onChange={handleInputChange} userPreferences={props.userPreferences} name='longitude' width='85%' access='false' displayVal={state.longitude} latVal={state.latitude} lngVal={state.longitude} marginLeft='10' ></MakeTextInput  >
              </div>

              <div style={{ heigh: '160px', width: '100%', marginBottom: '15px' }}>
                {photoMarkerIcon(
                  colorMarker,
                  props.leftToolbarState.editable
                )}
              </div>

              <div style={{ position: "relative", top: 0, marginBottom: 20 }}>
                <div></div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  top: 0,
                  marginBottom: 20,
                }}
              >
                <label
                  htmlFor="notes"
                  className="label-style"
                  style={{ marginBottom: 10 }}
                >
                  Notes:
                </label>
                <textarea
                  name="notes"
                  id="notes"
                  className="marker-notes"
                  style={{
                    height: "150px",
                    background: "#333333 0% 0% no-repeat padding-box",
                    borderRadius: 5,
                    opacity: 1,
                    border: "none",
                    width: "99%",
                  }}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              {editable && editable.weatherObservation &&
                <div style={{
                  position: 'relative',
                  marginBottom: 20
                }}>
                  <label htmlFor='notes'
                    className='label-style'
                    style={{ marginBottom: 10 }}>Smart Photo Marker&#8482; Data:
                  </label>
                  <div className='marker-weather-container'>
                    <div style={{ width: '100%', height: '100%' }}>
                      <div className='weather-data-header' >
                        <p style={{}}>Weather Data</p>
                      </div>
                      <div className='weather-data-value' >
                        <div style={{ display: 'flex' }}>
                          <h1>{`${userPreferences.units == "imperial" ? jsonObject && jsonObject.temparature : Math.round((jsonObject && jsonObject.temparature - 32) / 1.8)}\u00B0`}</h1>
                          <p>{userPreferences.units == "imperial" ? 'F' : 'C'}</p>
                          <img src={jsonObject && jsonObject.iconUrl}
                            style={{ width: jsonObject && jsonObject.iconUrl ? 20 : 0, height: 20, marginLeft: 20 }}
                          ></img>
                          <p style={{ marginLeft: 5, marginTop: 2 }}>{jsonObject && jsonObject.weatherPrimary}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>
          </div>

          <div
            style={{
              width: "95%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              position: "relative",
              bottom: 0,
              margin: 0,
              padding: 10,
              top: 10,
            }}
          >
            <button style={{ width: "40%", margin: 0, backgroundColor: "grey" }} onClick={() => props.collapseLeftToolbar()} >
              Cancel
            </button>
            <button style={{ width: "40%", margin: 0, backgroundColor: "#589500" }} onClick={() => savePhoto()}>
              Save Changes
            </button>
          </div>

          {imageViewModel ? <ImageViewModel
            remove={() => { setImageViewModel(false) }}
            ImageUrl={props.leftToolbarState.editable ? imageUrl : imageFile && URL.createObjectURL(imageFile)}
            type='photo' /> : null}

          <div className="confirm-removal-popup"></div>
          <div className="discard-popup"></div>
        </div >
      }
    </>
  )
}

const mapStateToProps = state => ({
  mapReferenceThreed: state.mapReferenceThreed,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  token: state.auth.token,
  leftToolbarState: state.leftToolbarState,
  // mapReference: state.mapReference(),
  markerGroups: state.markerGroups,

  user: state.user,
  disableMapObj: state.disableMapObj,
  userPreferences: state.userPreferences,
  markerCenter: state.markerCenter,
  vendors: state.vendors,
  auth: state.auth,
  infoWindow: state.infoWindow,
  photos: state.photos
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  markerCreateRequest: (payload) => dispatch(markerCreateRequest(payload)),
  markerUpdateRequest: (payload) => dispatch(markerUpdateRequest(payload)),
  photoUpdateRequest: (payload) => dispatch(photoUpdateRequest(payload)),
  photoCreateRequest: (payload) => dispatch(photoCreateRequest(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(ThreeDPhotoMarkerDetails)

